$('.js-validate-search-mail').validate({
  rules: {
    'session[email]': {
      required: true,
    },
  },
});
